// extracted by mini-css-extract-plugin
export default {"container":"c1-z"};